import styled, {css} from 'styled-components';

import {
  LoadingButton as BaseLoadingButton,
  Select as BaseSelect,
  Td as BaseTd,
  Th as BaseTh,
  Tr as BaseTr,
  NewNumberInputField,
  getTableCellWidth,
} from '@edna/components';
import {Label} from '@edna/components/FormField';
import {Stack} from '@edna/components/primitives';
import {Column as BaseColumn} from '@edna/components/primitives/Layout';
import {mixins} from '@edna/components/styles';
import {TSize, TSpacingSize} from '@edna/components/types';

import {Badge, StatusIcon as BaseStatusIcon} from 'src/components';
import {TableHead} from 'src/components/List';
import {BigText as BaseBigText, getFontSize} from 'src/components/primitives';

export const Select = styled(BaseSelect)`
  width: 400px;
  margin: 0;
`;

type TCenterRowProps = {
  size?: TSize;
};

export const InfoRow = styled.div<TCenterRowProps>`
  ${({size}) => getFontSize(size)};
  ${mixins.flexAlign('initial', 'center')}
  flex-flow: row wrap;
`;

export const DetailsLabel = styled.div`
  ${({theme}) => css`
    color: ${theme.branding.content.secondary};
    margin-right: ${theme.spacing.s1};
    &::after {
      content: ':';
    }
  `}
`;

export const Column = styled(BaseColumn)`
  margin-bottom: ${({theme}) => theme.spacing.s4};
`;

export const SuccessImage = styled.svg`
  ${mixins.wh('350px', '250px')};
`;

export const BigText = styled(BaseBigText)`
  margin-bottom: ${({theme}) => theme.spacing.s2};
`;

export const BillTd = styled(BaseTd)`
  width: 140px;
`;

export const BillTh = styled(BaseTh)`
  width: 140px;
`;

export const StatusIcon = styled(BaseStatusIcon)`
  ${mixins.wh('12px')}
  flex-shrink: 0;
  ${({theme}) => css`
    margin: 0 ${theme.spacing.s1} ${theme.spacing.s1} 0;
  `}
`;

export const BilledEventTables = styled.div`
  margin-bottom: ${({theme}) => theme.spacing.s4};
`;

export const InputPaymentUserId = styled(NewNumberInputField)`
  width: 420px;
  max-width: 420px;
`;

export const SmallLabel = styled(Label)`
  ${mixins.f2};
`;

export const PaymentTh = styled(BaseTh)`
  ${getTableCellWidth(['12%', '10%', '20%', '20%', '38%'])}
`;

export const PaymentTd = styled(BaseTd)<{size?: TSpacingSize}>`
  ${({size}) => mixins.stack({size, direction: 'ROW', align: 'center'})}
  ${getTableCellWidth(['12%', '10%', '20%', '20%', '38%'])}
`;

export const PaymentTr = styled(BaseTr)`
  width: 100%;
`;

export const PaymentTableHead = styled(TableHead)`
  top: 0;
  width: 100%;
`;

export const PaymentBadge = styled(Badge)`
  margin-right: auto;
`;

export const RefundNumberInput = styled(NewNumberInputField)`
  max-width: 146px;
  margin-top: ${({theme}) => theme.spacing.s2};
  margin-bottom: ${({theme}) => theme.spacing.s4};
`;

export const MaxContentWrapper = styled(Stack)`
  min-width: max-content;
`;

export const SearchButton = styled(BaseLoadingButton)`
  margin-top: 28px;
`;
